import { handleActions } from 'redux-actions';

import { TranslatedCollectionToCanonical } from 'ha/constants/SearchPageCollections';
import {
  CanonicalCollection,
  TypeFilterValue,
  PropertyTypeFilterCount,
} from 'ha/types/SearchFilters';

import { Actions } from '../constants';
import { CollectionFilterState } from './Types';

const initialState: CollectionFilterState = {
  collection: '',
  categories: [],
  listingCount: {},
};

interface Payload {
  filtersCount: {
    propertyType: PropertyTypeFilterCount;
  };
  categories: TypeFilterValue;
  collection: CanonicalCollection;
  localizedKind: any;
}

export default handleActions<CollectionFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount.propertyType,
    }),
    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      // TODO: Localized kind is a bad name for that part of the URL
      { payload: { localizedKind, categories = [] } },
    ) => ({
      ...state,
      collection: localizedKind
        ? TranslatedCollectionToCanonical[localizedKind]
        : '',
      categories: Array.isArray(categories) ? categories : [categories],
    }),
  },
  initialState,
);

export const getCollection = (state: CollectionFilterState) => state.collection;
export const getCategories = (state: CollectionFilterState) => state.categories;
